import React from "react";
import { Link, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function PublicShell() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-surface">
      <header className="sticky top-0 z-40 border-b border-line bg-surface/90 px-5 py-3.5 backdrop-blur-md">
        <div className="mx-auto flex max-w-6xl items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="public-home">
            <img src="/better-days-mark.png" alt="Better Days" className="h-6 w-auto" />
            <span className="text-[15px] font-bold tracking-tight text-ink">Better Days</span>
          </Link>
          <nav className="hidden items-center gap-7 text-sm font-medium text-muted md:flex">
            <Link to="/biomarkers" className="text-ink" data-testid="public-nav-biomarkers">Biomarkers</Link>
            <Link to="/shop" className="hover:text-ink" data-testid="public-nav-shop">Shop</Link>
            <Link to="/sol" className="hover:text-ink" data-testid="public-nav-sol">Sol</Link>
          </nav>
          <div className="flex items-center gap-3">
            {user ? (
              <Link to="/app/bloodwork" data-testid="public-goto-app"
                className="rounded-full bg-brand px-4 py-2 text-sm font-semibold text-white transition-transform hover:-translate-y-0.5">
                My bloodwork
              </Link>
            ) : (
              <>
                <Link to="/login" className="text-sm font-semibold text-ink hover:text-brand" data-testid="public-signin">Sign in</Link>
                <Link to="/register" data-testid="public-signup"
                  className="rounded-full bg-brand px-4 py-2 text-sm font-semibold text-white transition-transform hover:-translate-y-0.5">
                  Start free
                </Link>
              </>
            )}
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-6xl p-5 sm:p-8">
        <Outlet />
      </main>

      <footer className="border-t border-line px-5 py-8 text-center text-sm text-muted">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 sm:flex-row">
          <span>© {new Date().getFullYear()} Better Days · For information only, not medical advice</span>
          <div className="flex items-center gap-5">
            <Link to="/privacy-policy" className="hover:text-ink">Privacy Policy</Link>
            <Link to="/returns-policy" className="hover:text-ink">Returns Policy</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
